import { PageContext } from "../../service/PageContext";

export abstract class Component {
  protected constructor(
    protected readonly _element: HTMLElement,
    protected readonly _pageContext?: PageContext
  ) {}

  public async init?(): Promise<void> {
    return;
  }
}
